import React, { useState } from 'react';

export default function ToolBarDash({ mudaEstado }) {
    const [ativo, setAtivo] = useState("novo");

    function handleBollNovoEvento(e) {
        e.preventDefault();
        setAtivo("novo");
        mudaEstado(true, false);
    }

    function handleBollListaEvento(e) {
        e.preventDefault();
        setAtivo("lista");
        mudaEstado(false, true);
    }

    return (
        <div className="bg-urb-card-sidebar border-b border-urb-border px-4 py-2 flex items-center gap-2">
            <button
                type="button"
                onClick={handleBollNovoEvento}
                className={`px-4 py-2 rounded-lg text-sm font-semibold transition-colors cursor-pointer border-none ${
                    ativo === "novo"
                        ? "bg-urb-primary/10 text-urb-primary"
                        : "bg-transparent text-urb-text-secondary hover:text-white hover:bg-white/5"
                }`}
            >
                Novo Evento
            </button>
            <button
                type="button"
                onClick={handleBollListaEvento}
                className={`px-4 py-2 rounded-lg text-sm font-semibold transition-colors cursor-pointer border-none ${
                    ativo === "lista"
                        ? "bg-urb-primary/10 text-urb-primary"
                        : "bg-transparent text-urb-text-secondary hover:text-white hover:bg-white/5"
                }`}
            >
                Acompanhar Eventos
            </button>
        </div>
    );
}
